<script>
import VueCharts from 'vue-chartjs'
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: ['data', 'options'],
  computed: {
    chartData: function() {
      return this.data;
    },
  },
  methods: {
    updateMyChart: function () {
      for(var i = 0; i < this.$data._chart.data.datasets.length; i++){
        this.$data._chart.data.datasets[i].data = Array.from(this.chartData.datasets[i].data);
      }
      this.$data._chart.update();
    },
  },
  mounted () {
    this.renderChart(this.chartData, {
      responsive: true,
      scales: {
        yAxes: [{
          name: 'count',
          type: 'linear',
          position: 'left',
          scalePositionLeft: true,
          scaleLabel: {
            display: false,
            labelString: 'Count'
          },
          ticks: {
            beginAtZero: true,
          }
        }],
        xAxes: [{
          //name: 'position',
          type: 'category',
          //position: 'left',
          scalePositionRight: true,
          scaleLabel: {
            display: true,
            labelString: 'Position'
          },
          ticks: {
            stepSize: 1,
          }
        }],
      }
    })
  },
  watch: {
    data: function() {
      this.updateMyChart();
    }
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/BarChart.vue